import FormValidation from '../form-validation';
import { messageBoxSuccess, messageBoxError } from '../message-box';

class DownloadForm {
  protected elScope: HTMLFormElement;

  protected lang = 'de';

  protected idFile = '';

  protected filename: string | null = null;

  private isLocked = false;

  protected nameSelector = '#';

  protected nameInputSelector = 'input';

  private elInput: HTMLInputElement;

  private elButtonClose: HTMLElement;

  private errorMessage = 'Ungültig';

  private formValidation: FormValidation;

  protected fileImageContainer: NodeListOf<any>;

  protected fileImage: HTMLImageElement;

  protected createAccountCheckbox: HTMLInputElement | null | undefined = null;

  protected formToggleTrigger: HTMLElement | null | undefined = null;

  protected formToggleTarget: NodeListOf<HTMLElement> | null | undefined = null;

  public callback: Function | null = null;

  private apiBaseUrl: string | undefined;

  init() {
    this.apiBaseUrl = document.body.dataset.apiBaseUrl;
    this.elScope = document.querySelector(this.nameSelector) as HTMLFormElement;
    this.elInput = this.elScope.querySelector(this.nameInputSelector) as HTMLInputElement;
    this.elButtonClose = this.elScope.parentElement?.parentElement?.querySelector('.m-popup__close') as HTMLElement;
    this.errorMessage = this.elScope.dataset.error || 'Ungültig';

    this.createAccountCheckbox = this.elScope?.querySelector('input[name="create_account"]') as HTMLInputElement;
    this.formToggleTrigger = this.elScope?.querySelector('.js-o-modal-form__toggle-trigger') as HTMLElement;
    this.formToggleTarget = this.elScope?.querySelectorAll('.js-o-modal-form__toggle-target');

    this.fileImageContainer = document.querySelectorAll('.js-popup__download-mail__slider') as NodeListOf<HTMLElement>;
    // this.fileImage = this.fileImageContainer.querySelector('img') as HTMLImageElement;

    this.elInput.addEventListener('keyup', () => this.removeError());

    const accountPasswordInputs = this.elScope?.querySelectorAll('.l-form-m__account-i') as NodeListOf<HTMLInputElement>;
    if (this.createAccountCheckbox) {
      this.createAccountCheckbox.addEventListener('change', () => {
        this.elScope?.classList.toggle('is-account-required');

        accountPasswordInputs.forEach(passwordInput => {
          passwordInput.required = !passwordInput.required;
        });
      });
      accountPasswordInputs[0].focus();
    }

    if (this.formToggleTrigger) {
      this.formToggleTrigger.addEventListener('change', () => {
        this.formToggleTarget?.forEach(element => {
          element.classList.toggle('hidden');
          element.querySelectorAll('input, select').forEach(inputField => {
            if((inputField as HTMLInputElement).dataset.required) {
              let inputLabel = inputField.nextElementSibling as HTMLElement;
              (inputField as HTMLInputElement).required = !(inputField as HTMLInputElement).required;
              inputLabel.innerText = inputLabel.innerText.indexOf('*') >= 0 ? inputLabel.innerText.slice(0, -1) : inputLabel.innerText + '*';
            }
          });
        });
      })
    }

    this.formValidation = new FormValidation(
      this.elScope,
      this.handlerFormSubmit.bind(this)
    );
    this.formValidation.init();
  }

  private async handlerFormSubmit() {
    if (this.isLocked) return;

    this.setLock();

    const result = await this.submitData();
    this.elScope.classList.remove('loading');
    if (result.successful) {
      // this.elInput.value = '';
      this.elScope.closest('#popup-email')?.classList.add('success');
      const swiperContainer = this.elScope.closest('#popup-email')?.querySelector('.o-modal-success-message .swiper-container') as any;
      if(swiperContainer) {
        swiperContainer.swiper.update();
      }

      // this.elButtonClose.click();
    } else {
      this.handleError(result.response);
    }
    this.setLock(false);

    if (this.callback) {
      // console.log('callback');
      this.callback();
    }
  }

  private setLock(isLocked: boolean = true) {
    this.isLocked = isLocked;
    this.elScope.classList.toggle('is-sending', this.isLocked);
  }

  protected async handleError(response: {status: string, field: string}) {
    switch (response.status) {
      default:
        this.addError();
        break
    }
  }

  protected async submitData(): Promise<{successful: boolean, response: any}> {
    let successful = false;
    let response = 'error';
    let validationResult = true;

    const endpoint = this.getEndpoint();
    const method = endpoint.substring(endpoint.length - 1, endpoint.length) == '/' ? 'GET' : 'POST';
    this.elScope.classList.add('loading');

    let createAccount = false;

    // validate pw
    if ((this.createAccountCheckbox as HTMLInputElement)?.checked) {
      let password = this.elScope?.querySelector('input[name="password"]') as HTMLInputElement;
      let passwordRepeat = this.elScope?.querySelector('input[name="password-repeat"]') as HTMLInputElement;

      if (password.value === passwordRepeat.value && password.value !== '') {
        createAccount = true;
      } else {
        messageBoxError({
          contentDe: 'Es ist ein Fehler aufgetreten. Bitte überprüfe Deine Passwörter.',
          contentEn: 'An error appeared. Please check your passwords.',
        });

        password.classList.add('has-error');
        passwordRepeat.classList.add('has-error');
        password.addEventListener('keydown', () => password.classList.remove('has-error'));
        passwordRepeat.addEventListener('keydown', () => passwordRepeat.classList.remove('has-error'));

        validationResult = false;
      }
    }

    if (validationResult == false) {
      this.elScope.classList.remove('loading');

      return {
        successful: false,
        response: {
          status: 200,
          field: {}
        }
      };
    }

    // Create the new account first
    if(createAccount && this.createAccountCheckbox?.checked) {
      const createAccountSuccess = await this.createAccount();
      if (createAccountSuccess == false) {
        this.elScope.classList.remove('loading');
        return {
          successful: false,
          response: {
            status: 200,
            field: {}
          }
        };
      }
    }
    const userMail = (this.elScope.querySelector('input[name="email"]') as HTMLInputElement)?.value;
    // Request the download
    let requestOptions = {
      method: method
    };
    if (method == 'POST') {
      Object.defineProperty(requestOptions, 'body', {value: new FormData(this.elScope)});
    };
    await fetch(endpoint, requestOptions)
    .then((res) => {
      if (res.headers.get('Content-Disposition') !== null && res.status == 200) {
        return res.blob().then((blob) => {
          const file = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = file;
          a.download = this.filename ?? file.substr(file.lastIndexOf('/') + 1);
          document.body.appendChild(a);
          a.style.display = 'none';
          a.click();
          document.body.removeChild(a);
          successful = true;
          return {ok: true};
        });
      }
      return res.json();
    })
    .then(data => {
      if (data.success == true || data.success === 'true') {
        successful = true;
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ action: null }) // reset data layer items
        window.dataLayer.push({
          event: 'generate_lead',
          lead: {
            type: 'form_download',
            email: userMail,
            content_type: 'file',
            file_title: data.hasOwnProperty('file_title') ? data.file_title : 'unknown',
            new_lead: data.hasOwnProperty('is_first_contact') && data.is_first_contact ? 'Yes' : 'No'
          }
        });
      }
    })
    .catch(error => {
      console.warn(error);
      response = 'error undefined';
    });

    return { successful, response };
  }

  protected getEndpoint(): string {
    const { idFile, lang } = this;
    const valBase64 = window.btoa(this.elInput.value || '');
    const nameInput = this.elScope.querySelector('input[name="firstName"]') as HTMLInputElement;
    const nameBase64 = nameInput ? window.btoa(nameInput.value || '') : '';
    const apiBaseUrl = document.body.dataset.apiBaseUrl;
    return `${apiBaseUrl}api/v1/download/id/${idFile}/lang/${lang}/flex/${valBase64}/${nameBase64}`;
  }

  setCallback(callback: Function) {
    this.callback = callback;
  }

  setData(idFile: string, lang: string, fileImages:Array<any> = [], filename:string|null = null, popupContent:Object|null = null) {
    this.lang = lang;
    this.idFile = idFile;
    this.elInput.value = '';
    if(filename) {
      this.filename = filename;
      const filenameInput = document.querySelector('#js-popup-download__filename') as HTMLInputElement;
      if(filenameInput) {
        filenameInput.value = filename;
      }
    }
    this.removeError();
    this.setImages(fileImages);
    if(popupContent) {
      this.setPopupContent(popupContent);
    }
  }

  private setPopupContent(popupContent:any) {
    const popup:HTMLElement = document.querySelector('#popup-email') as HTMLElement;

    if(popup) {
      const preTitle = popup.querySelector('.o-modal-headline__pre-title') as HTMLElement;
      const headline = popup.querySelector('.o-modal-headline__heading') as HTMLElement;
      const text = popup.querySelector('.o-modal-text__content') as HTMLElement;
      const successText = popup.querySelector('.o-modal-success-message__text') as HTMLElement;
      const successPreTitle = popup.querySelector('.o-modal-success-message__pre-title') as HTMLElement;

      if(preTitle) {
        preTitle.innerText = popupContent.preTitle;
      }
      if(headline) {
        headline.innerText = popupContent.fieldTitle;
      }
      if(text) {
        text.innerText = popupContent.text;
      }
      if(successText) {
        successText.innerHTML = popupContent.successText;
      }
      if(successPreTitle) {
        successPreTitle.innerText = popupContent.preTitle;
      }
    }
  }

  private setImages(fileImages:Array<any>) {
    const { fileImageContainer } = this;
    fileImageContainer.forEach( container => {

      if (fileImages.length == 0) {
        container.parentElement.classList.add('is-hidden');
      } else {
        container.parentElement.classList.remove('is-hidden');
      }

      const carousel = container.swiper;
      const swiperButtons = container.parentElement.querySelectorAll('.swiper-button');
      let innerHtml = '';


      if(fileImages.length) {
        fileImages.forEach( (image) => {
          innerHtml += `
          <div class="swiper-slide">
            <div class="o-modal-images-videos__asset">
              <img src="${image.url}" alt="${image.title}" fetchpriority="high" />
            </div>
          </div>
          `;
        });
        container.classList.remove('d-none');
      } else {
        container.classList.add('d-none');
      }
      if(fileImages.length == 1) {
        swiperButtons.forEach( (button: any) => {
          button.classList.add('d-none');
        });
      } else {
        swiperButtons.forEach( (button: any) => {
          button.classList.remove('d-none');
        });
      }
      container.querySelector('.swiper-wrapper').innerHTML = innerHtml;
      if(carousel) {
        carousel.update();
        carousel.loopDestroy();
        carousel.loopCreate();
        carousel.update();
      }
    });
  }

  private addError() {
    const { elInput, errorMessage } = this;

    if (!elInput.classList.contains('has-error')) {
      elInput.classList.add('has-error');
      const errorMessageDiv = document.createElement('div');
      errorMessageDiv.classList.add('error-message');
      errorMessageDiv.innerText = errorMessage;

      elInput.parentElement?.appendChild(errorMessageDiv);
    }
  }

  private removeError() {
    const elError = this.elInput.parentElement?.querySelector('.error-message');
    this.elInput.classList.remove('has-error');
    if (elError) {
      elError.remove();
    }
  }

  async createAccount() {

    let success = false;
    const data = new FormData();

    // @ts-ignore
    data.append(window.csrfTokenName, window.csrfTokenValue);
    data.append('action', 'users/save-user');

    let salutation = this.elScope.querySelector('select[name="salutation"]');
    if (salutation instanceof HTMLSelectElement) {
      data.append('fields[salutation]', salutation.value);
      data.append('address[fields][addressTitle]', salutation.value);
    }

    let fullName = '';
    let firstName = this.elScope.querySelector('input[name="firstName"]');
    if (firstName instanceof HTMLInputElement) {
      data.append('firstName', firstName.value);
      data.append('fields[firstName]', firstName.value);
      data.append('address[firstName]', firstName.value);
      fullName = firstName.value;
    }

    let lastName = this.elScope.querySelector('input[name="lastName"]');
    if (lastName instanceof HTMLInputElement) {
      data.append('lastName', lastName.value);
      data.append('fields[lastName]', lastName.value);
      data.append('address[lastName]', lastName.value);
      fullName = fullName + ' ' + lastName.value;
    }

    data.append('fullName', fullName);
    data.append('fields[fullName]', fullName);
    data.append('address[fullName]', fullName);

    let email = this.elScope.querySelector('input[name="email"]');
    if (email instanceof HTMLInputElement) {
      data.append('email', email.value);
      data.append('fields[email]', email.value);
    }

    let phone = this.elScope.querySelector('input[name="phoneNumber"]');
    if (phone instanceof HTMLInputElement) {
      data.append('fields[phone]', phone.value);
      data.append('address[fields][phoneNumber]', phone.value);
    }

    let organization = this.elScope.querySelector('input[name="organization"]');
    let company = this.elScope.querySelector('input[name="company"]');
    if (organization instanceof HTMLInputElement) {
      data.append('fields[companyName]', organization.value);
      data.append('address[organization]', organization.value);
    }
    else if (company instanceof HTMLInputElement) {
      data.append('fields[companyName]', company.value);
      data.append('address[organization]', company.value);
    }

    let postalCode = this.elScope.querySelector('input[name="postalCode"]');
    if (postalCode instanceof HTMLInputElement) {
      data.append('address[postalCode]', postalCode.value);
    }

    let locality = this.elScope.querySelector('input[name="locality"]');
    if (locality instanceof HTMLInputElement) {
      data.append('address[locality]', locality.value);
    }

    let street = this.elScope.querySelector('input[name="street"]');
    if (street instanceof HTMLInputElement) {
      data.append('address[addressLine1]', street.value);
    }

    let notes = this.elScope.querySelector('input[name="addressNotes"]');
    if (notes instanceof HTMLInputElement) {
      data.append('address[fields][addressNotes]', notes.value);
    }

    let country = this.elScope.querySelector('select[name="country"]');
    if (country instanceof HTMLSelectElement) {
      data.append('address[countryCode]', country.value);
    }

    let password = this.elScope.querySelector('input[name="password"]');
    if (password instanceof HTMLInputElement) {
      data.append('password', password.value);
    }

    await fetch(this.apiBaseUrl!, {
      method: 'post',
      headers: {
        Accept: 'application/json',
      },
      body: data,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.id && res.id != "") {
          success = true;
          messageBoxSuccess({
            contentDe: 'Account erfolgreich angelegt. Bitte überprüfe dein E-Mail-Postfach.',
            contentEn: 'Account successfully created. Please check your email inbox.',
          });

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'sign_up',
            user: {
              email: data.get('email')
            }
          });
        } else {
          throw new Error(JSON.stringify(res.errors));
        }
      })
      .catch((error) => {
        let errorObj = JSON.parse(error.message);

        if (errorObj.email) {
          messageBoxError({
            contentDe: errorObj.email[0],
            contentEn: errorObj.email[0],
          });
        }
        else {
          messageBoxError({
            contentDe: 'Account konnte nicht angelegt werden',
            contentEn: 'Account could not be created',
          });
        }
      });

    return success;
  }
}

export default DownloadForm;
